// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { SliderCash } from '@advisor-app/components';
import { selectWorkflowType } from '@advisor-app/store/slices/workflow';
import { useAppSelector } from '@advisor-app/store/store';
import { SectionContainer } from '@shared/ui-kit/components';
import { useEffect, useMemo } from 'react';
import { useSliderCash } from '../hooks';
import { useTranslation } from 'react-i18next';

export type InvestSelectorProps = {
  onChangeInvestment: (value: number) => void;
};

export const InvestSelector = ({ onChangeInvestment }: InvestSelectorProps) => {
  const { t } = useTranslation();
  const workflow = useAppSelector(selectWorkflowType);
  const { handleInvestmentChange, setPortfolioCash, investment, taxCash } =
    useSliderCash();

  const minValue = useMemo(
    () => (workflow === 'tax-harvesting' ? taxCash : 5000),
    [workflow, taxCash],
  );

  useEffect(() => {
    onChangeInvestment(investment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [investment]);

  return (
    <SectionContainer
      variant="h3"
      title={t('ai-builder.select-investment', { ns: 'ai-builder' }) as string}
    >
      <SliderCash
        value={investment}
        onInputBlur={setPortfolioCash}
        onChangeCommitted={setPortfolioCash}
        onChangeInputValue={handleInvestmentChange}
        onChangeSlider={handleInvestmentChange}
        min={minValue}
      />
    </SectionContainer>
  );
};
